import gql from 'graphql-tag';

export default gql`
  mutation showPlayback($eventId: ID!, $eventDate: String) {
    showPlayback(eventId: $eventId, eventDate: $eventDate)
  }
`;
